import React from 'react';
import { objectiveUnit, UnitQuantity } from './formatUnit';

const ObjectiveUnitAffix = ({
  children,
  quantity,
}: {
  children: React.ReactNode;
  quantity?: UnitQuantity | null;
}) => {
  const unit = objectiveUnit(quantity);
  if (!unit) {
    return <>{children}</>;
  }
  return (
    <span style={{ alignItems: 'center', display: 'inline-flex', gap: 6 }}>
      {children}
      <span aria-hidden="true">{unit}</span>
    </span>
  );
};

export default ObjectiveUnitAffix;
